import Contacts from "../../components/ContactDetails/Index";
import { InfoObjThree } from "../../Data/InfoComponentsData";

const Contact = () => {
  return <Contacts {...InfoObjThree} />;
};

export default Contact;
